export default "__VITE_ASSET__c36b9582__"